import(/* webpackMode: "eager" */ "/codebuild/output/src3027618808/src/ai-ecom/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3027618808/src/ai-ecom/node_modules/next/dist/client/link.js");
